
import Vue from 'vue'
import vButton from '@/components/vButton.vue'
import vPopup from '@/components/vPopup.vue'
import loadingLottieAll from '@/components/loadingLottieAll.vue'
import Component from 'vue-class-component'
import success from '@/assets/images/success.png'
import fail from '@/assets/images/fail.png'
import { Watch } from 'vue-property-decorator'
import {
  getVerifyCode,
  login,
  searchUserPhone,
  searchUserNumber,
  entrance,
  getOpenUserStep,
  clientPerson,
  saveList,
  saveCompany,
  auroraLogin,
  getAccounTime,
  getKeyValue,
} from '@/api'
import { Dialog, Toast } from 'vant'
import {
  addition,
  setSStorageInfo,
  nextStep,
  clearSStorage,
  getSStorageInfo,
  nextStepName,
  getQueryParams,
  getCompany,
  isSource,
  getJdUrl,
} from '@/common'
import openView from '@/common/open-view'
import vBottomPop from '@/components/vBottomPop.vue'
import cjs from '@/utils/CryptoJs/CryptoJs_AES'
import { isWechatEnvironment, testWx } from '@/common/wx-share'
import { inDev } from '@/common'
import loginLogo from '@/assets/images/auroraLogin.png'
import { getUrlArg } from '@space/utils'
const win = window as any
@Component({
  components: {
    vButton,
    vPopup,
    loadingLottieAll,
    vBottomPop,
  },
})
export default class IndexView extends Vue {
  mobilephone = '' //手机号
  password = '' // 密码
  isSent = false // 是否正在发送
  loading = false //加载中
  // 用户信息
  userInfo: any = {
    // userId: '',
    // mobilephone: '',
    // token: '',
  }
  // 从业人员提示
  popupInfo = {
    title: '温馨提示',
    text: `当前登录的手机账户(${this.mobilephone})为证券从业人员的手机号，不允许开通股票账户，仅可开通基金账户，确认继续使用（${this.mobilephone}）开户？`,
    status: false,
    cancelLabel: '继续开户',
    confirmLabel: '更换账户',
    cancelWidth: 1.17,
    confirmWidth: 1.17,
  }
  // 未收到短信提示
  codeInfo = {
    title: '没收到短信？',
    text: `点击“获取语音验证码”，我们将以语音电话形式告知您验证码，请注意接听`,
    status: false,
    confirmLabel: '获取语音验证码',
    confirmWidth: 2.17,
    cancelShow: true,
  }
  codeTitle = '获取验证码' // 验证码按钮文案
  codeType = 0
  // 协议勾选
  agreement = false
  cardShow = false
  orAgreement = false
  clientPhone = ''
  source = ''
  urlParam: any = {}
  type: any = getUrlArg('type')
  aurora: any = {
    appKey: '19b52af9cd26f3c15c05fbfb',
  }
  dateTime = new Date().getTime()
  // 协议勾选气泡提示
  get agreepop() {
    return !this.agreement
  }
  set agreepop(val) {
    //
  }
  @Watch('$route.name')
  onRouterChange(val: any) {
    if (val === 'IndexView') {
      this.agreement = this.orAgreement
    }
  }
  async created() {
    this.urlParam = getQueryParams()
    this.getKeyValueFun()
  }
  async mounted() {
    if (!this.urlParam?.reset) clearSStorage('token')
    // 设置 toast 图标
    this.$toast.setDefaultOptions('success', {
      icon: success,
    })
    this.$toast.setDefaultOptions('fail', {
      icon: fail,
    })
    this.source = this.urlParam.source || '0016000100000000'
    if (this.source) {
      clearSStorage('source')
      setSStorageInfo('source', this.source) // 渠道来源
    } else {
      setSStorageInfo('source', '0016000100000000') // 渠道来源
    }
    if (this.urlParam.productId) {
      clearSStorage('productId')
      setSStorageInfo('productId', this.urlParam.productId) // 产品id：京东投顾会携带
    }
    if (this.urlParam.salesDepartment) {
      clearSStorage('salesDepartment')
      setSStorageInfo('salesDepartment', this.urlParam.salesDepartment) //分支机构编号：京东投顾会携带
    }
    if (this.urlParam.branchnum) {
      clearSStorage('branchnum')
      setSStorageInfo('branchnum', this.urlParam.branchnum) // 建设银行分行对应的营业部编号
    }

    if (this.urlParam?.reset) this.reIn()

    if (isWechatEnvironment()) {
      testWx()
    }
    this.loading = true
    this.jgInit()
  }

  // 动态拼接当前页面URL所有参数（排除source，已作为channel_no传递）
  // 兼容参数在search中（?key=val）和hash路由中（#/?key=val）两种场景
  buildExtraParams(): string {
    const queryStr =
      window.location.search ||
      (window.location.hash.includes('?') ? '?' + window.location.hash.split('?')[1] : '')
    const params = new URLSearchParams(queryStr)
    const parts: string[] = []
    params.forEach((value, key) => {
      if (key !== 'source') {
        parts.push(key + '=' + encodeURIComponent(value))
      }
    })
    return parts.length ? '&' + parts.join('&') : ''
  }

  getKeyValueFun() {
    const param = {
      keyList: ['sdnewkh'],
    }
    getKeyValue(param)
      .then((res: any) => {
        // 打开新开户入口
        if (res.code == '0' && res.data[0].valued == 'Y') {
          let newOrigin =
            window.location.origin.indexOf('mi.jzsec.com') !== -1
              ? 'https://h5.huayuanstock.com'
              : 'https://fxckhsp-test.huayuanstock.com:8443'
          window.location.href =
            newOrigin +
            '/tk-stkkh-view/views/index.html?channel_no=' +
            this.source +
            this.buildExtraParams() +
            '#/index'
        }
      })
      .catch(() => {
        // Toast.fail('获取开户开关失败,请重新尝试')
      })
  }

  reIn() {
    this.userInfo = JSON.parse(getSStorageInfo('cParam') || null) || {}
    this.checkUser()
  }

  //获取url传入的推荐人手机号
  decodeUrl() {
    let urlQuery: any = getQueryParams()
    let value = urlQuery?.referrer || urlQuery?.mobilephone || ''
    if (!value) {
      return
    }
    //对url的数据进行解析
    value = decodeURIComponent(value)
    const aes = require('@/api/aes')
    const keyHex = aes.enc.Utf8.parse('iloveyou'),
      iv = aes.enc.Utf8.parse('iloveyou'),
      valueHex = aes.enc.Base64.parse(value),
      decrypted = aes.AES.decrypt(
        {
          ciphertext: valueHex,
        },
        keyHex,
        {
          iv: iv,
          mode: aes.mode.CBC,
        }
      )
    value = decrypted.toString(aes.enc.Utf8)
    this.clientPhone = value
    console.log(111, this.clientPhone)
  }
  closeCardPop() {
    this.cardShow = false
  }
  showCard() {
    this.cardShow = true
  }
  /**
   * 验证码倒计时结束
   */
  codeFinish() {
    this.isSent = false
    this.codeTitle = ' 重新获取'
  }
  /**
   *继续开户
   */
  continueOpen() {
    // this.popupInfo.status = false
    this.checkUserNumber()
  }
  /**
   * 更换账户
   */
  changeUser() {
    this.popupInfo.status = false
  }
  /**
   * 关闭提示
   */
  closeOver() {
    this.popupInfo.status = false
  }
  // 跳转协议详情
  toProtocol(type: number) {
    // openView('protocol-item', {
    //   source: 'login',
    //   pType: type,
    // })
    this.agreement = this.orAgreement
    this.agreement = true
    this.$router.push({
      name: 'ProtocolItem',
      params: {
        source: 'login',
        pType: '' + type,
      },
    })
  }
  resetStorage() {
    clearSStorage('token')
    clearSStorage('cParam')
    clearSStorage('secWorker')
    clearSStorage('channelFlag')
    clearSStorage('channelInfo')
    clearSStorage('accountId')
    clearSStorage('branchno')
    clearSStorage('pageFlag')
    clearSStorage('accountInfo')
    clearSStorage('cardNum')
    clearSStorage('selectBankCode')
    clearSStorage('haveBuser')
    clearSStorage('pwd')
    clearSStorage('branchInfo')
  }
  /**
   * 重置
   */
  reset() {
    this.mobilephone = ''
    this.password = ''
    this.isSent = false
    this.codeTitle = ' 获取验证码'
  }
  /**
   * 计数器重置
   */
  countDownReset() {
    const countDown: any = this.$refs.countDown
    countDown.reset()
  }
  // 计算能否点击下一步
  computedDisableClick() {
    if (!this.mobilephone) {
      return true
    }
    if (!this.password) {
      return true
    }
    if (!this.agreement) {
      return true
    }
    return false
  }
  /**
   *  登陆接口
   */
  login() {
    //
    this.resetStorage()
    if (!this.verifyInfo()) {
      return
    }
    const param = {
      mobilephone: this.mobilephone,
      verifyCode: this.password,
      fromwhichsys: '0',
    }
    this.loading = true

    login(param)
      .then((res: any) => {
        this.loading = false
        if (res && res.code == 0) {
          const data = res.data
          this.userInfo.userId = data.id || ''
          this.userInfo.mobilephone = this.mobilephone = data.loginmobile || ''
          // this.popupInfo.text = `当前登录的手机账户(${data.loginmobile})为证券从业人员的手机号，不允许开通股票账户，仅可开通基金账户，确认继续使用（${data.loginmobile}）开户？`
          this.userInfo.token = data.token || ''
          this.userInfo.sex = data.sex || ''
          this.userInfo.userName = data.buser_name || ''
          setSStorageInfo('cParam', JSON.stringify(this.userInfo))
          setSStorageInfo('token', data.token)
          this.checkUser()
        } else {
          Toast.fail(res?.msg || '服务异常')
        }
      })
      .catch((e: any) => {
        this.loading = false
        console.log(e)
      })
  }
  /**
   * 信息校验
   */
  verifyInfo() {
    if (!this.mobilephone) {
      Toast.fail('请输入手机号')
      return false
    }
    if (this.mobilephone.length != 11) {
      Toast('请输入正确手机号')
      return false
    }
    if (!this.password) {
      Toast.fail('请输入验证码')
      return false
    }
    if (!this.agreement) {
      Toast.fail('请阅读并同意注册协议和隐私政策')
      return false
    }
    return true
  }
  /**检查用户是否可以开户*/
  checkUser() {
    const pParam = {
      mobilephone: this.userInfo.mobilephone,
      userId: this.userInfo.userId,
    }
    this.loading = true
    searchUserPhone(pParam)
      .then((res: any) => {
        this.loading = false
        if (res.code != 0) {
          this.popupInfo.text = res.msg
          this.popupInfo.status = true
          setSStorageInfo('secWorker', true)
        } else {
          this.checkUserNumber()
        }
      })
      .catch(() => {
        this.loading = false
      })
  }
  /**
   * 获取开户状态
   */
  checkUserNumber() {
    const param = {
      userId: this.userInfo.userId,
    }
    this.loading = true
    searchUserNumber(param)
      .then((res: any) => {
        this.loading = false
        setSStorageInfo('channelFlag', res.data.channelFlag)
        if (res?.data?.servicePerson && Object.keys(res.data.servicePerson).length) {
          setSStorageInfo('channelInfo', res.data.servicePerson)
        }
        this.entrance(res.code)
      })
      .catch((e: any) => {
        this.loading = false
        console.log(e)
      })
  }
  sendAudioCode() {
    this.codeType = 1
    this.codeInfo.status = false
    this.getCheckCode()
  }
  getCheckCode() {
    this.codeInfo.status = false
    if (!this.mobilephone) {
      Toast.fail('请输入手机号')
      return
    }
    this.isSent = true
    const countDown: any = this.$refs.countDown
    countDown?.reset()
    countDown?.start()
    const param = {
      mobilephone: this.mobilephone,
      useVoice: this.codeType, // 0短信，1语音
    }
    this.loading = true
    getVerifyCode(param)
      .then((res: any) => {
        this.loading = false
        if (res && res.code == '0') {
          if (this.codeType == 1) {
            Toast.success(
              '获取语音验证码成功,请注意您的手机将收到包含验证码的语音电话，请注意接听。'
            )
          } else {
            Toast.success('验证码发送成功')
          }
        } else {
          if (res.code == '-7') {
            this.codeInfo.status = true
          } else {
            this.isSent = false
            this.codeTitle = ' 获取验证码'
            countDown?.reset()
            Toast.fail(res.msg)
          }
        }
      })
      .catch((e: any) => {
        this.loading = false
        this.isSent = false
        this.codeTitle = ' 获取验证码'
        countDown?.reset()
        console.log(e)
      })
  }
  /**
   * 非现场开户入口
   * @param code 开户状态：0开户成功，-1未开户，-2开户中
   */
  async entrance(code: number) {
    const param = {
      mobileNo: this.userInfo.mobilephone,
      loginFlag: '0',
      iscompany: getCompany(this.source),
      companyFlag: getCompany(this.source),
      infocolectChannel: getSStorageInfo('infocolectChannel') || '3',
      company: '',
    }
    this.loading = true
    const res: any = await entrance(param)
    this.loading = false
    if (res.code != 0) {
      Toast(res.msg)
      return
    }
    const data: any = res.data
    this.userInfo.accountId = res.data.accountId
    setSStorageInfo('accountId', res.data.accountId)
    setSStorageInfo('branchno', res?.data?.branchno)
    setSStorageInfo('accountInfo', JSON.stringify(res.data))
    // 存放京东投顾需要的信息
    if (isSource('0002')) {
      this.loading = true
      const cres: any = await saveList({
        accountId: this.userInfo.accountId,
      })
      this.loading = false
      if (cres.code == '0') {
        if (
          !cres.data.typeShangHai &&
          !cres.data.typeShenZhen &&
          !cres.data.cnTypeShangHai &&
          !cres.data.cnTypeShenZhen
        ) {
          setSStorageInfo('isTa', 'Y')
        } else {
          clearSStorage('isTa')
        }
        console.log('初始化银行、股东卡成功', res)
      } else {
        Toast('初始化银行信息失败')
      }

      let jDInfo = {
        userId: this.userInfo.userId || '',
        name: data?.custname || '',
        mobile: this.userInfo.mobilephone || '',
        documentType: data?.idtype || '',
        documentNum: data?.idno || '',
        validity: data?.idenddate
          ? data?.idenddate?.includes('长期')
            ? '3000-12-31'
            : data?.idenddate
          : '',
        address: data?.addr,
        salesDepartment: this.urlParam.salesDepartment || '',
        productId: this.urlParam.productId || '',
        riskStatus: '',
        riskLevel: '',
        riskLevelDesc: '',
        forbid_tag: '',
        riskTime: '',
        realNameAuthStatus: '',
        realNameTime: '',
      }
      clearSStorage('jDInfo')
      setSStorageInfo('jDInfo', JSON.stringify(jDInfo))
    }
    if (code === 0) {
      if (getSStorageInfo('isTa') === 'Y' && isSource('0002')) {
        Dialog.confirm({
          message: `您已在华源证券开通理财账户，但未开通证券账户，将不能获得足够的适当性以签约投顾产品，详情请咨询小助理电话${
            this.urlParam.phoneNum || '95305'
          }`,
          confirmButtonText: '我知道了',
          showCancelButton: false,
          confirmButtonColor: '#286DF7',
        }).then(() => {
          //
        })
      }
      if (getSStorageInfo('isTa') !== 'Y') {
        const msg = isSource('0002')
          ? '您已在我司开通证券账户，点击确定跳转投顾产品签约流程。'
          : '您已在我司开通证券账户'
        Dialog.confirm({
          message: msg,
          confirmButtonText: '我知道了',
          showCancelButton: false,
          confirmButtonColor: '#286DF7',
        }).then(() => {
          //TODO:跳转京东投顾
          if (isSource('0002')) {
            let data: any = JSON.parse(getSStorageInfo('jDInfo') || '{}')
            console.log(data)
            data = {
              ...data,
              riskStatus: 1,
              realNameAuthStatus: 1,
              token: getSStorageInfo('token') || '',
              productId: this.urlParam.productId || '',
            }
            const cc = cjs.encrypt(JSON.stringify(data), '', '')
            console.log('解密', cjs.decrypt(cc))
            openView(getJdUrl(), {
              userInfo: cc,
            })
          }
        })
      } else {
        openView(this.urlParam?.reset ? 'uploadPhoto' : 'result')
      }
    }
    if (code == -1) {
      if (isSource('0003') || isSource('0023') || isSource('0024') || isSource('0030')) {
        const jyshInfo = {
          L1OrgCd: this.urlParam.L1OrgCd,
          OrgCd: this.urlParam.OrgCd,
          UsrInf: decodeURIComponent(this.urlParam.UsrInf),
          tId: this.urlParam.tId,
        }
        const nhInfo = {
          bid: this.urlParam?.bid,
          bbr: this.urlParam?.bbr,
          qbr: this.urlParam?.qbr,
          qid: this.urlParam?.qid,
          tm: this.urlParam?.tm,
          tel: this.urlParam?.tel,
        }
        const xyInfo = { sale_id: this.urlParam?.sale_id }
        const source = this.urlParam?.source.substring(0, 4)
        const infos: any = {
          '0003': jyshInfo,
          '0023': xyInfo,
          '0024': nhInfo,
          '0030': xyInfo,
        }
        const params = {
          chanelId: this.urlParam.source || '0016000100000000',
          userId: res.data.accountId,
          mobileno: this.userInfo.mobilephone,
          chanelMsg: JSON.stringify(infos[source] || {}),
        }
        await saveCompany(params)
      }
      openView('uploadPhoto')
    }
    if (code == -2) {
      if (
        res.data?.needAccount ||
        res.data?.needAccountReason ||
        res.data?.needBank ||
        res.data?.needBankReason ||
        res.data?.needBusinessPassword ||
        res.data?.needFirstId ||
        res.data?.needFirstReason ||
        res.data?.needFirstVideo ||
        res.data?.needFundPassword ||
        res.data?.needHomeaddr ||
        res.data?.needHomeaddrReason ||
        res.data?.needPhotoBack ||
        res.data?.needPhotoBackReason ||
        res.data?.needPhotoFront ||
        res.data?.needPhotoFrontReason ||
        res.data?.needPhotoNohat ||
        res.data?.needPhotoNohatReason ||
        res.data?.needThirdDeposit ||
        res.data?.needVideo ||
        res.data?.needVideoReason
      ) {
        openView('result')
        return
      }
      if (!addition(res.data)) {
        this.getOpenStep()
      }
    }
  }
  /**
   * 跳转下一个页面
   */
  getOpenStep() {
    const param = {
      accountId: this.userInfo.accountId,
    }
    this.loading = true
    getOpenUserStep(param)
      .then((res: any) => {
        this.loading = false
        if (res.code == 0) {
          setSStorageInfo('pageFlag', JSON.stringify(res.data))
          // openView('video-auth')
          const name = nextStepName()
          if (name === '提交结果') {
            clearSStorage('notFirst')
            setSStorageInfo('notFirst', true)
          }
          const step = nextStep() || ''
          console.log('step >> ', step)
          if (step === 'video-auth') {
            openView('bind-bank', { showVideo: '1' })
          } else {
            openView(step)
          }
        }
      })
      .catch((e: any) => {
        this.loading = false
        console.log(e)
      })
  }
  /**打开收不到验证码页面 */
  toNoCode() {
    this.loading = false
    this.agreement = this.orAgreement
    this.agreement = true
    this.$router.push({
      name: 'NoCode',
    })
  }
  changeAgree() {
    this.agreement = !this.agreement
  }
  //极光一键登录初始化
  jgInit() {
    win.JVerificationInterface.init({
      appkey: this.aurora.appKey, // 极光官网中创建应用后分配的 appkey，必填
      debugMode: true, // 设置是否开启 debug 模式。true 则会打印更多的日志信息。设置 false 则只会输出 w、e 级别的日志
      // domainName:"http://huminios.com",//开发者域名
      domainName: inDev ? 'https://tmi3.jzsec.com' : 'https://mi.jzsec.com', //开发者域名
      fail: (data: any) => {
        this.loading = false
        console.error('JVerificationInterface init fail:' + JSON.stringify(data))
      },
      success: (data: any) => {
        console.log('JVerificationInterface init success:' + JSON.stringify(data))
        this.getServerTime()
        this.setCustomUIWithConfig()
        this.addEventListen()
        this.getToken()
      },
    })
  }
  setCustomUIWithConfig() {
    // 本地仅支持调整联通一键登录页的logo和应用名，其他运营商需要单独申请到运营商配置，请联系对应商务
    win.JVerificationInterface.setCustomUIWithConfig({
      logo: loginLogo,
      appName: '华源证券',
      btnName: 2,
      loginBtnColor: '#FBD6B2',
      //登录按钮颜色
      loginTextColor: '#8B4F21',
      customPolicyLink1: [
        '《华源证券用户注册协议》',
        'https://mi.jzsec.com/third-open-accounts/protocol-item.html#/?pType=0&source=login',
      ],
      customPolicyLink2: [
        '《隐私政策》',
        'https://mi.jzsec.com/third-open-accounts/protocol-item.html#/?pType=1&source=login',
      ],

      customPolicyLinkColor: '#000000',
      // 是否显示其他登录方式按钮
      // isDisplayOtherWayBtn: true,
      // 其他登录方式按钮文字
      // customOtherWayText: '其他手机号登录',
      // 其他登录方式按钮文字颜色
      // customOtherWayTextColor: '#8B4F21',
    })
  }
  //联通用户事件回调
  /*
  {code: '3001', msg: '关闭了页面'}
  {code: '3002', msg: '已同意协议条款'}
  {code: '3003', msg: '未同意协议条款'}
  {code: '3004', msg: '开始输入'}
  {code: '3005', msg: '输入完成'}
  {code: '3006', msg: '点击了登录'}
  {code: '3007', msg: '点击了其他登录按钮'}

  */
  addEventListen() {
    win.JVerificationInterface.addEventListen({
      event: (data: any) => {
        console.log('example addEventListen:' + JSON.stringify(data))
      },
    })
  }
  loginAuthDialog() {
    // 一键登录接口，默认尝试顺序：移动>联调>电信
    // 实际使用中建议在初始化成功回掉中调用此接口
    win.JVerificationInterface.loginAuth({
      type: 'dialog', //可填全屏：full，弹窗：dialog，不填默认全屏
      fail: (data: any) => {
        this.loading = false
        console.log(`登录错误:${JSON.stringify(data)}`)
        console.error('example loginAuth fail:' + JSON.stringify(data))
      },
      success: (data: any) => {
        console.log(`获取到token为：${data.content}`)
        let token = data.content
        console.log('example loginAuth success:' + token)
        this.auroraLogin(token)
      },
    })
  }
  //获取服务器时间
  getServerTime() {
    getAccounTime({})
      .then((res: any) => {
        this.loading = false
        if (res && res.data && res.code === 0) {
          this.dateTime = res.data.tradeTime
        }
      })
      .catch(() => {
        this.loading = false
      })
  }
  //获取运营商，电信不支持配置协议，非电信号码才展示一键登录
  getToken() {
    // 获取运营商token，默认尝试顺序：移动>联通>电信
    // 实际使用中建议在初始化成功回掉中调用此接口
    win.JVerificationInterface.getToken({
      fail: (data: any) => {
        this.loading = false
        console.error('example getToken fail:' + JSON.stringify(data))
      },
      success: (data: any) => {
        // var token = data.content
        console.log('当前运营商:', data.operater)
        if (data.operater && data.operater != 'CT') {
          this.loginAuthDialog()
        } else {
          this.loading = false
        }
      },
    })
  }

  /**
   *  极光一键登陆接口
   */
  auroraLogin(auroraToken: string) {
    //
    this.resetStorage()
    const param = {
      appKey: this.aurora.appKey,
      h5Flag: true,
      jgToken: auroraToken,
      time: this.dateTime,
      fromwhichsys: '1010',
    }
    this.loading = true
    auroraLogin(param)
      .then((res: any) => {
        this.loading = false
        console.log('极光登录返回参数', JSON.stringify(res))
        if (res && res.code == 0) {
          const data = res.data
          this.userInfo.userId = data.id || ''
          this.userInfo.mobilephone = this.mobilephone = data.loginmobile || ''
          this.userInfo.token = data.token || ''
          this.userInfo.sex = data.sex || ''
          this.userInfo.userName = data.buser_name || ''
          setSStorageInfo('cParam', JSON.stringify(this.userInfo))
          setSStorageInfo('token', data.token)
          this.checkUser()
        } else {
          Toast.fail(res?.msg || '服务异常')
        }
      })
      .catch((e: any) => {
        this.loading = false
        console.log(e)
      })
  }
}
